import { useQuery } from "@tanstack/react-query";
import { fetchStages, stagesQueryKey } from "views/settings-crm/api";
import {
  StageKind,
  type ApplicationStage
} from "views/settings-crm/types/stage";

const byPosition = (a: ApplicationStage, b: ApplicationStage) =>
  Number(a.position) - Number(b.position);

export const applicationStagesQueryKey = stagesQueryKey(StageKind.Application);

export const useApplicationStages = () =>
  useQuery({
    queryKey: applicationStagesQueryKey,
    queryFn: () => fetchStages<ApplicationStage>(StageKind.Application),
    select: (stages) => [...stages].sort(byPosition),
    staleTime: 5 * 60 * 1000
  });
